import { ActionReducer, createReducer, on } from '@ngrx/store';

import { setComplianceReportHistoryStore } from '../compliance-report-data/compliance-report-data.actions';
import { setComplianceReportHistoryFilters } from '../filters/filters.actions';
import { setComplianceDesignationTypeOption } from './compliance-designation-type.actions';

// Interfaces / Types / Enums
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
import { ComplianceDesignationTypeOptions } from 'FoldersApp/apps/compliance-report-history-app/interfaces/compliance-report-type-options.interface';

export const INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE: ComplianceDesignationTypeOptions = {
    [CustomPDFReportDesignation.DELIVERABLE]: true,
    [CustomPDFReportDesignation.DRAFT]: true,
};

export const complianceDesignationType: ActionReducer<ComplianceDesignationTypeOptions> = createReducer(
    INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE,
    on(setComplianceDesignationTypeOption, (state: ComplianceDesignationTypeOptions, action) => {
        // Create new state with the appropriate reportDesignationOption selected/deselected to match the action
        const newState: ComplianceDesignationTypeOptions = { ...state };
        const key = action.designationTypeOption.value as keyof ComplianceDesignationTypeOptions;
        newState[key] = action.designationTypeOption.checked;
        return newState;
    }),
    on(setComplianceReportHistoryFilters, (state: ComplianceDesignationTypeOptions, action) => {
        return { ...action.designationType };
    }),
    on(setComplianceReportHistoryStore, (state: ComplianceDesignationTypeOptions, action) => {
        return { ...action.designationType };
    })
);
